(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-announcement-bar-script');
    if (!window.announcementBarScript && $url && $url.dataset.designMode !== 'yes') {
      window.announcementBarScript = $url.value;

      var $script = document.createElement('script');
      $script.src = window.announcementBarScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["answer-lottery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const $url = document.querySelector('.as-answer-lottery-script');
    if (!window.answerLotteryScript && $url && $url.dataset.designMode !== 'yes') {
      window.answerLotteryScript = $url.value;
      const $script = document.createElement('script');
      $script.src = window.answerLotteryScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chief-hela-drop"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url2 = document.querySelector('.as-chief-hela-drop-script')
    if (!window._chiefHelaDrop && $url2) {
      window._chiefHelaDrop = $url2.value
      var $script = document.createElement('script')
      $script.src = window._chiefHelaDrop
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-featured-product-collection-script');
    if (!window.featuredCollectionV2 && $url && $url.dataset.designMode !== 'yes') {
      window.featuredCollectionV2 = $url.value;
      var $script = document.createElement('script');
      $script.src = window.featuredCollectionV2;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-content-slide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-featured-content-slide-script');
    if (!window.featuredContentSlideScript && $url && $url.dataset.designMode !== 'yes') {
      window.featuredContentSlideScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.featuredContentSlideScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-social-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-featured-social-video-script');
    if (!window.featuredSocialVideoScript && $url && $url.dataset.designMode !== 'yes') {
      window.featuredSocialVideoScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.featuredSocialVideoScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finishes-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-finishes-gallery-script')
    if (!window._finishesGallery && $url && $url.dataset.designMode !== 'yes') {
      window._finishesGallery = $url.value
      var $script = document.createElement('script')
      $script.src = window._finishesGallery
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider-a"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-image-slider-new-script');
    if (!window.imageSliderNew && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliderNew = $url.value;

      var $script = document.createElement('script');
      $script.src = window.imageSliderNew;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab-new"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-new-script')
    if (!window.imageTabNew && $url && $url.dataset.designMode !== 'yes') {
      window.imageTabNew = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTabNew
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-toggle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-image-text-toggle-script');
    if (!window.imageTextToggleScript && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextToggleScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.imageTextToggleScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-image-with-reviews-script');
    if (!window.imageWithReviewsScript && $url) {
      window.imageWithReviewsScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.imageWithReviewsScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kai1-product"]) return;
  try {
    
  (function () { 
    var $url = document.querySelector('.as-kai1-product-page-script');
    if (!window.kai1ProductPageScript && $url) {
      window.kai1ProductPageScript = $url.value;

      var $script = document.createElement('script');
      $script.src = window.kai1ProductPageScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-main-collection-product-grid-script');
    if (!window.mainCollectionProductGridScript && $url && $url.dataset.designMode !== 'yes') {
      window.mainCollectionProductGridScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.mainCollectionProductGridScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v3"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search-v2"]) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-main-collection-product-grid-script');
    if (!window.mainCollectionProductGridScript && $url && $url.dataset.designMode !== 'yes') {
      window.mainCollectionProductGridScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.mainCollectionProductGridScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["member-level-rights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-member-level-rights-script');
    if (!window.memberLevelRights && $url && $url.dataset.designMode !== 'yes') {
      window.memberLevelRights = $url.value;

      var $script = document.createElement('script');
      $script.src = window.memberLevelRights;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overlay-image-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-overlay-image-slider-script')
    if (!window.overlayImageSlider && $url && $url.dataset.designMode !== 'yes') {
      window.overlayImageSlider = $url.value
      var $script = document.createElement('script')
      $script.src = window.overlayImageSlider
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-11-days-of-giving-activity"]) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-product-11-days-of-giving-activity-script');
    // $url.dataset.designMode !== 'yes'
    if (!window.product11DaysOfGivingActivityScript && $url) {
      window.product11DaysOfGivingActivityScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.product11DaysOfGivingActivityScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-auto-recommendation"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-product-auto-recommendation-script');
    if (!window.productAutoRecommendationScript && $url) {
      window.productAutoRecommendationScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.productAutoRecommendationScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
   })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-by-color-swatches"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-product-collection-by-color-swatches-script');
    if (!window.productCollectionByColorSwatchesScript && $url && $url.dataset.designMode !== 'yes') {
      window.productCollectionByColorSwatchesScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.productCollectionByColorSwatchesScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-by-purchase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-product-collection-by-purchase-script');
    if (!window.productCollectionByPurchaseScript && $url && $url.dataset.designMode !== 'yes') {
      window.productCollectionByPurchaseScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.productCollectionByPurchaseScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-by-thumbnails"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-product-collection-by-thumbnails-script');
    if (!window.productCollectionByThumbnailsScript && $url && $url.dataset.designMode !== 'yes') {
      window.productCollectionByThumbnailsScript = $url.value;
      var $script = document.createElement('script');
      $script.src = window.productCollectionByThumbnailsScript;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-color"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-recommended-color-script')
  if (!window.recommendedColor && $url && $url.dataset.designMode !== 'yes') {
    window.recommendedColor = $url.value
    var $script = document.createElement('script')
    $script.src = window.recommendedColor
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["register-form-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-register-form-page-v2-script');
    if (!window._registerFormPageV2 && $url && $url.dataset.designMode !== 'yes') {
      window._registerFormPageV2 = $url.value;
      var $script = document.createElement('script');
      $script.src = window._registerFormPageV2;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["register-form"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-register-form-page-script')
    if (!window._registerFormPage && $url && $url.dataset.designMode !== 'yes') {
      window._registerFormPage = $url.value
      var $script = document.createElement('script')
      $script.src = window._registerFormPage
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["student-discount"]) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-student-discount-section-script');
    if (!window._studentDiscountSection && $url && $url.dataset.designMode !== 'yes') {
      window._studentDiscountSection = $url.value;
      var $script = document.createElement('script');
      $script.src = window._studentDiscountSection;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner-new"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
